import { WSElementProps } from "@wingspanhq/fe-component-library";
import { Tabs } from "../../../../components/Tabs";
import {
  PAYEES_ALL_PATH,
  PAYEES_ARCHIVED_PATH,
  PAYEES_ELIGIBLE_PATH,
  PAYEES_INELIGIBLE_PATH,
  PAYEES_NOT_SIGNED_UP_PATH
} from "../../utils";
import { usePayeeRowsSummaryQuery } from "../../../../query/search/payee/queries/usePayeeRowsSummaryQuery";
import { PayerPayeeEngagementSearchableStatus } from "../../../../services/search";
import { useIsEngagementsActive } from "../../../../shared/hooks/useIsEngagementsActive";

export const DashboardTabs: React.FC<WSElementProps> = props => {
  const isEngagementsActive = useIsEngagementsActive();

  // Query for all payees (excluding inactive)
  const queryAllPayees = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: {
        "!=": PayerPayeeEngagementSearchableStatus.Inactive
      }
    }
  });

  // Query for not signed up payees
  const queryNotSignedUp = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.NotSignedUp
    }
  });

  // Query for ineligible payees
  const queryIneligible = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.NotEligible
    }
  });

  // Query for eligible payees
  const queryEligible = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.Eligible
    }
  });

  // Query for archived payees
  const queryArchived = usePayeeRowsSummaryQuery({
    filter: {
      searchableStatus: PayerPayeeEngagementSearchableStatus.Inactive
    }
  });

  return (
    <Tabs
      {...props}
      tabs={[
        {
          label: "Active",
          path: PAYEES_ALL_PATH,
          badge: queryAllPayees.data?.listSize
        },
        {
          label: "Not signed up",
          path: PAYEES_NOT_SIGNED_UP_PATH,
          badge: queryNotSignedUp.data?.listSize
        },
        {
          label: "Ineligible",
          path: PAYEES_INELIGIBLE_PATH,
          badge: queryIneligible.data?.listSize
        },
        {
          label: "Eligible",
          path: PAYEES_ELIGIBLE_PATH,
          badge: queryEligible.data?.listSize
        },
        {
          label: "Archived",
          path: PAYEES_ARCHIVED_PATH,
          badge: queryArchived.data?.listSize
        }
      ]}
    />
  );
};
